import { render, staticRenderFns } from "./BillingManager.vue?vue&type=template&id=67285b0e&scoped=true"
import script from "./BillingManager.vue?vue&type=script&lang=js"
export * from "./BillingManager.vue?vue&type=script&lang=js"
import style0 from "./BillingManager.vue?vue&type=style&index=0&id=67285b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67285b0e",
  null
  
)

export default component.exports